import { permissionService } from 'shared/services';
import FormBuilderList from '../containers/FormList/FormList.container';
import FormBuilderDetail from '../containers/FormDetail/FormDetail.container';
import ServiceList from '../containers/ServiceList/ServiceList.container';
import ServiceCreate from '../containers/ServiceCreate/ServiceCreate.container';
import ServiceDetail from '../containers/ServiceDetail/ServiceDetail.container';
import ServiceUpdate from '../containers/ServiceUpdate/ServiceUpdate.container';
import Billers from '../containers/BillerList/BillerList.container';
import BillerCreate from '../containers/BillerCreate/BillerCreate.container';
import BillerUpdate from '../containers/BillerUpdate/BillerUpdate.container';
import BillerDetail from '../containers/BillerDetail/BillerDetail.container';
import Transactions from '../containers/Transactions/Transactions.container';
import TransactionMeta from '../containers/TransactionMeta/TransactionMeta.container';
import TncCreate from '../containers/TncCreate/TncCreate.container';
import TncDetail from '../containers/TncDetail/TncDetail.container';
import TncList from '../containers/TncList/TncList.container';
import TncUpdate from '../containers/TncUpdate/TncUpdate.container';

// import Settlement from '../containers/Settlement/Settlement.container';
// import AggregatorList from '../containers/AggregatorList/AggregatorList.container';

import billerRoute from '.';

const { checkPermission } = permissionService;

const AllBillersNavigation = () => [
  ...(checkPermission('Form Builder:read', true)
    ? [{ path: billerRoute.FORM_BUILDERS, component: FormBuilderList }]
    : []),
  ...(checkPermission('Form Builder:read', true)
    ? [{ path: billerRoute.FORM_BUILDERS_FILTER, component: FormBuilderList }]
    : []),
  ...(checkPermission('Form Builder:read', true)
    ? [{ path: billerRoute.FROM_DETAIL, component: FormBuilderDetail }]
    : []),
  ...(checkPermission('Service:read', true)
    ? [{ path: billerRoute.SERVICES, component: ServiceList }]
    : []),
  ...(checkPermission('Service:read', true)
    ? [{ path: billerRoute.SERVICES_FILTER, component: ServiceList }]
    : []),
  ...(checkPermission('Service:create', true)
    ? [{ path: billerRoute.SERVICES_CREATE, component: ServiceCreate }]
    : []),
  ...(checkPermission('Service:read', true)
    ? [{ path: billerRoute.SERVICES_DETAIL, component: ServiceDetail }]
    : []),
  ...(checkPermission('Service:update', true)
    ? [{ path: billerRoute.SERVICES_EDIT, component: ServiceUpdate }]
    : []),
  ...(checkPermission('Biller:read', true)
    ? [{ path: billerRoute.BILLERS, component: Billers }]
    : []),
  ...(checkPermission('Biller:read', true)
    ? [{ path: billerRoute.BILLERS_FILTER, component: Billers }]
    : []),
  ...(checkPermission('Biller:create', true)
    ? [{ path: billerRoute.BILLERS_CREATE, component: BillerCreate }]
    : []),
  ...(checkPermission('Biller:read', true)
    ? [{ path: billerRoute.BILLERS_DETAIL, component: BillerDetail }]
    : []),
  ...(checkPermission('Biller:update', true)
    ? [{ path: billerRoute.BILLERS_EDIT, component: BillerUpdate }]
    : []),
  ...(checkPermission('Transaction Log:read', true)
    ? [{ path: billerRoute.TRANSACTIONS, component: Transactions }]
    : []),
  ...(checkPermission('Transaction Log:read', true)
    ? [{ path: billerRoute.TRANSACTIONS_FILTER, component: Transactions }]
    : []),
  ...(checkPermission('Transaction Log:read', true)
    ? [{ path: billerRoute.TRANSACTION_META, component: TransactionMeta }]
    : []),
  ...(checkPermission('Tnc:create', true)
    ? [{ path: billerRoute.TNC_CREATE, component: TncCreate }]
    : []),
  ...(checkPermission('Tnc:read', true)
    ? [{ path: billerRoute.TNC_LIST, component: TncList }]
    : []),
  ...(checkPermission('Tnc:read', true)
    ? [{ path: billerRoute.TNC_LIST_FILTER, component: TncList }]
    : []),
  ...(checkPermission('Tnc:read', true)
    ? [{ path: billerRoute.TNC_DETAIL, component: TncDetail }]
    : []),
  ...(checkPermission('Tnc:update', true)
    ? [{ path: billerRoute.TNC_EDIT, component: TncUpdate }]
    : []),
  // ...[{ path: billerRoute.SETTLEMENT, component: Settlement }],
  // ...[{ path: billerRoute.SETTLEMENT_FILTER, component: Settlement }],
  // { path: billerRoute.AGGREGATORS, component: AggregatorList },
];

export default AllBillersNavigation;
